export const ADD_MEMBER = 'add-member';
export const MEMBER_NAME = 'member-name';
